import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "../../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import { formatUnitsForReport } from "../../../../helpers/units";
import paginationFactory from "react-bootstrap-table2-paginator";
import moment from "moment";
import { getDateRangeFromMonth } from "../../../../helpers/commonFunctions";
import { useLocation } from "react-router-dom";

const FinishedProductClosedOrders = (props) => {
  const { SearchBar } = Search;
  const urlParams = new URLSearchParams(window.location.search);
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [selectedSection, setSelectedSection] = useState(
    urlParams.get("section") ? urlParams.get("section") : "All",
  );
  const [page, setPage] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [sizePerPage] = useState(30);
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const monthYear = params.get("month");
    const orderId = params.get("order_id");

    if (monthYear) {
      const dateRange = getDateRangeFromMonth(monthYear);
      if (dateRange) {
        setDateFrom(dateRange.startDate);
        setDateTo(dateRange.endDate);
        if (orderId) {
          setSearchQueryOrderID(orderId);
        }
      }
    } else {
      const currentDay = new Date();
      setDateFrom(formatDate(currentDay));
      setDateTo(formatDate(currentDay));
    }
  }, []);

  const [searchQueryBranch, setSearchQueryBranch] = useState("");
  const [searchQueryOrderID, setSearchQueryOrderID] = useState("");
  const [localFilteredOrders, setLocalFilteredOrders] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [shouldLoadData, setShouldLoadData] = useState(false);

  const performLocalSearch = async (query1, query2) => {
    if (isSearching) return;

    if (
      (!query1 || query1.trim() === "") &&
      (!query2 || query2.trim() === "")
    ) {
      setSearchQueryBranch("");
      setSearchQueryOrderID("");
      setAllOrders([]);
      setLocalFilteredOrders([]);
      setPage(1);
      setShouldLoadData(true);
      return;
    }

    if (query1 && query1.length < 3 && query2 && query2.length < 3) return;

    setIsSearching(true);
    setAllOrders([]);
    setLocalFilteredOrders([]);
    setPage(1);
    try {
      await loadAllOrders(query1, query2);
    } catch (error) {
      console.error("API search failed:", error);
      setAllOrders([]);
      setLocalFilteredOrders([]);
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      performLocalSearch(searchQueryOrderID, searchQueryBranch);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQueryBranch, searchQueryOrderID]);

  useEffect(() => {
    if (!searchQueryBranch && !searchQueryOrderID && shouldLoadData) {
      loadAllOrders(searchQueryOrderID, searchQueryBranch);
      setShouldLoadData(false);
    }
  }, [dateFrom, dateTo, selectedSection, selectedBranch, page, shouldLoadData]);

  useEffect(() => {
    if (dateFrom && dateTo && selectedSection && selectedBranch) {
      loadAllOrders(searchQueryOrderID, searchQueryOrderID);
    }
  }, [dateFrom, dateTo, selectedSection, selectedBranch, page]);

  useEffect(() => {
    if (urlParams.get("section")) {
      setSelectedSection(urlParams.get("section"));
    }
    loadAllBranches();
    loadAllSections();
  }, []);

  const [allOrders, setAllOrders] = useState([]);

  const loadAllOrders = async (orderIdQuery, branchQuery) => {
    try {
      setIsSearching(true);
      const days_diff = moment(dateTo).diff(dateFrom, "days");
      if (days_diff > 31) {
        setAllOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (days_diff < 0) {
        setAllOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }
      setAllOrders([]);
      setLocalFilteredOrders([]);
      let url = process.env.REACT_APP_BASEURL + "productorders/getall_closed";
      const response = await postSubmitForm(url, {
        branch: selectedBranch,
        section: selectedSection,
        date_from: dateFrom,
        date_to: dateTo,
        page: page,
        limit: sizePerPage,
        order_query: orderIdQuery || "",
        branch_query: branchQuery || "",
      });

      if (response && response.status === 1) {
        setAllOrders(response.data);
        setTotalSize(response.totalPages);
        setLocalFilteredOrders(response.data);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSearching(false);
    }
  };
  const [allSections, setAllSections] = useState([]);
  const loadAllSections = async () => {
    let url = process.env.REACT_APP_BASEURL + "productsections/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllSections(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [allBranches, setAllBranches] = useState([]);
  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter((store) => store.type === "Branch");
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Avail. Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];
  const [orderDetailsModal, setOrderDetailsModal] = useState();
  const [selectedOrder, setSelectedOrder] = useState();

  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        const rowNumber = (+page - 1) * +sizePerPage + (+rowIndex + 1);
        return rowNumber;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),
      headerFormatter: (column) => (
        <div>
          {column.text}
          <div className="mt-1">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search Order ID..."
              value={searchQueryOrderID}
              onChange={(e) => setSearchQueryOrderID(e.target.value)}
            />
          </div>
        </div>
      ),
      headerStyle: (colum, colIndex) => ({
        width: "20%",
        verticalAlign: "top",
      }),
      style: { cursor: "pointer" },
    },
    {
      dataField: "branch_details.name",
      text: props.t("Branch Name"),
      headerFormatter: (column) => (
        <div>
          {column.text}
          <div className="mt-1">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search Branch..."
              value={searchQueryBranch}
              onChange={(e) => setSearchQueryBranch(e.target.value)}
            />
          </div>
        </div>
      ),
      headerStyle: (colum, colIndex) => ({
        width: "12%",
        verticalAlign: "top",
      }),
      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Branch Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      text: props.t("Order Date"),
      dataField: "date_to_process",
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      // formatter: (cell, row) => {
      //   return moment(row.date_to_process).format("DD-MM-YYYY HH:mm");
      // },
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Is Urgent?"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      formatter: (cell, row) => {
        if (row.is_urgent) {
          return props.t("Yes");
        } else {
          return props.t("No");
        }
      },
      style: { cursor: "pointer" },
    },

    {
      dataField: "status",
      text: props.t("Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "admin_remarks",
      text: props.t("Centre Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      text: props.t("Action"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
            <button
              class="btn btn-secondary btn-sm mr-2"
              onClick={() => {
                setSelectedOrder(row);
                setOrderDetailsModal(!orderDetailsModal);
              }}
            >
              {props.t("Details")}
            </button>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="_id"
          data={row.product_details}
          columns={columns}
          noDataIndication="No data to display."
          striped
          hover
          condensed
        />
      </div>
    ),
  };
  const rowStyle = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8", fontWeight: "500" };
    return style;
  };
  const columns_delivered_products = [
    {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Del. Qty."),
      dataField: "delivered_quantity",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Rec. Qty."),
      dataField: "received_quantity",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Finished Products")}
            title={props.t("Central Kitchen")}
            breadcrumbItem1={props.t("FP Order")}
            breadcrumbItem2={props.t("Closed Orders")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={6}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={6}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Closed Orders")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all closed orders here")}
                  </CardSubtitle>
                  {/* <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row> */}
                  <ToolkitProvider
                    keyField="_id"
                    key={`${allOrders + page + localFilteredOrders}`}
                    data={allOrders && allOrders}
                    columns={columns_external}
                    noDataIndication={props.t("No data to display.")}
                    bootstrap4
                    search
                  >
                    {(props_table) => (
                      <div>
                        <AvForm>
                          <Row>
                            {/* <Col lg={4}>
                              <Label>{props.t("Search")}</Label>
                              <SearchBar
                                {...props_table.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col> */}
                            <Col lg={4}>
                              <AvField
                                name="branch"
                                label={props.t("Branch")}
                                type="select"
                                value={selectedBranch}
                                onChange={(e) => {
                                  setSelectedBranch(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allBranches &&
                                  allBranches.map((branch) => {
                                    return (
                                      <option value={branch._id}>
                                        {branch.name}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                            <Col lg={4}>
                              <AvField
                                name="section"
                                label={props.t("Section")}
                                type="select"
                                value={selectedSection}
                                onChange={(e) => {
                                  setSelectedSection(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allSections &&
                                  allSections.map((section) => {
                                    return (
                                      <option value={section.section}>
                                        {section.section}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                          </Row>
                        </AvForm>
                        {/* <BootstrapTable
                          striped
                          hover
                          condensed
                          expandRow={expandRow}
                          rowStyle={rowStyle}
                          {...props_table.baseProps}
                        /> */}
                        <BootstrapTable
                          striped
                          hover
                          condensed
                          // remote={{ pagination: true }}
                          expandRow={expandRow}
                          rowStyle={rowStyle}
                          // pagination={paginationFactory(paginationOptions)}
                          {...props_table.baseProps}
                          onTableChange={(type, { page }) => {
                            if (type === "pagination") {
                              setPage(page);
                            }
                          }}
                          noDataIndication={() => (
                            <div className="text-center p-3">
                              {isSearching ? (
                                <div>
                                  <Spinner
                                    color="primary"
                                    size="sm"
                                    className="mr-2"
                                  />
                                  {props.t("Loading...")}
                                </div>
                              ) : searchQueryBranch ||
                                (searchQueryOrderID &&
                                  allOrders.length <= 0) ? (
                                props.t("No matching results found")
                              ) : (
                                props.t("No data to display.")
                              )}
                            </div>
                          )}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                  <div>
                    <br />

                    {[...Array(totalSize)].map((x, i) => (
                      <button
                        key={i}
                        onClick={() => {
                          setPage(i + 1);
                        }}
                        className={page === i + 1 ? "btn btn-primary" : "btn"}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>
                  <Modal
                    size="lg"
                    isOpen={orderDetailsModal}
                    toggle={() => setOrderDetailsModal(!orderDetailsModal)}
                  >
                    <ModalHeader
                      toggle={() => setOrderDetailsModal(!orderDetailsModal)}
                    >
                      {props.t("Delivery Details")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12} md={12}>
                                    <Label>Ordered Products</Label>
                                  </Col>

                                  <Col lg={12}>
                                    <BootstrapTable
                                      bootstrap4
                                      keyField="name"
                                      data={
                                        selectedOrder &&
                                        selectedOrder.product_details
                                      }
                                      columns={columns}
                                      noDataIndication="No data to display."
                                      striped
                                      hover
                                      condensed
                                    />
                                    <hr />
                                  </Col>

                                  {selectedOrder &&
                                  selectedOrder.delivery_details &&
                                  selectedOrder.delivery_details.length > 0 ? (
                                    <>
                                      <Col lg={12} md={12}>
                                        <br />
                                        <Label>
                                          <b>
                                            {props.t("Delivered Products")}{" "}
                                          </b>
                                        </Label>
                                      </Col>
                                      <Col lg={12} className="mb-4">
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          key="name"
                                          data={selectedOrder.delivery_details}
                                          columns={columns_delivered_products}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                        <hr />
                                      </Col>
                                    </>
                                  ) : null}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(FinishedProductClosedOrders)),
);
